"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseToken = void 0;
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var parseToken = exports.parseToken = function parseToken(token) {
  var result = '';
  if (token) {
    result = (0, _jwtDecode.default)(token);
  }
  return result;
};